import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import type { CommunityEssentialFolderModel } from '@/models'

import type { FolderBreadcrumb } from './community-essentials.types'

export const useFolderNavigation = () => {
  const { t } = useTranslation(['community-essentials'])
  const rootBreadcrumb: FolderBreadcrumb = { id: 0, name: t('community-essentials:title') }

  const [folderPath, setFolderPath] = useState<FolderBreadcrumb[]>([rootBreadcrumb])

  const currentFolder = folderPath[folderPath.length - 1]
  const isRoot = currentFolder.id === 0
  const depth = folderPath.length - 1

  const navigateToFolder = useCallback((folder: CommunityEssentialFolderModel) => {
    setFolderPath((prev) => [...prev, { id: folder.id, name: folder.name }])
  }, [])

  const navigateBack = useCallback(() => {
    setFolderPath((prev) => (prev.length > 1 ? prev.slice(0, -1) : prev))
  }, [])

  const navigateToBreadcrumb = useCallback((index: number) => {
    setFolderPath((prev) => prev.slice(0, index + 1))
  }, [])

  const navigateToRoot = useCallback(() => {
    setFolderPath([rootBreadcrumb])
  }, [rootBreadcrumb])

  const updateCurrentFolderName = useCallback((name: string) => {
    setFolderPath((prev) =>
      prev.map((crumb, i) => (i === prev.length - 1 ? { ...crumb, name } : crumb)),
    )
  }, [])

  return {
    currentFolder,
    depth,
    folderPath,
    isRoot,
    navigateBack,
    navigateToBreadcrumb,
    navigateToFolder,
    navigateToRoot,
    updateCurrentFolderName,
  }
}
